<template>
  <v-dialog :value="value" @input="$emit('input')" max-width="800px" persistent>
    <v-card>
      <v-card-title class="title">Manage Team to Campaign</v-card-title>
      <!-- <v-card-text class="body-2">
        <v-select
          v-model="selectedCSList"
          :items="cs_options"
          item-text="display"
          item-value="csData.id"
          :menu-props="{ maxHeight: '400' }"
          label="Community Operations"
          multiple
          filled
          hint="Select who is assigned to this Campaign"
          persistent-hint
        ></v-select>
      </v-card-text>
      <v-card-text class="body-2">
        <v-select
          v-model="selectedAMList"
          :items="am_options"
          item-text="display"
          item-value="amData.id"
          :menu-props="{ maxHeight: '400' }"
          label="Account Managers"
          multiple
          filled
          hint="Select who is assigned to this Campaign"
          persistent-hint
        ></v-select>
      </v-card-text> -->
      <v-card-text class="body-2">
        <AssignTeam
          @updateSelectedDedicated="updateSelectedDedicated"
          @updateSelectedSupporting="updateSelectedSupporting"
          :dedicatedData="dedicatedData"
          :supportingData="supportingData"
          :assignUsers="assignUsers"
        />
      </v-card-text>
      <v-card-actions>
        <v-btn color="red" id="close" text @click.native="$emit('input')">Close</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green" text @click="assignCS()">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AssignTeam from '../Client/AssignTeam';
import userAPIs from '../User/userAPIs';
import campaignAPIs from './campaignAPIs';
import config from '@/config';
export default {
  props: {
    value: Boolean,
    campaign: Object
  },
  components: {
    AssignTeam
  },
  data() {
    return {
      campaignData: null,
      selectedCSList: [],
      selectedAMList: [],
      adStrategist: [],
      accountManagers: [],
      // new assignee
      assignUsers: [],
      selectedDedicatedPersons: [],
      selectedSupportingPersons: [],
      dedicatedData: [],
      supportingData: []
    };
  },
  methods: {
    assignCS() {
      let assignedToLists = this.selectedDedicatedPersons.map(s => s.id)
      let assignedSupportingTo = this.selectedSupportingPersons.map(s => s.id)
      campaignAPIs
        .assignCsToCampaign(this.campaignData.id, { assignedTo: assignedToLists, assignedSupportingTo })
        .then(() => {
          this.$emit('updated', true)
          this.$emit('input')
        })
        .catch(err => console.error(err));
    },
    fetchCSlist(clientId, assignedTo) {
      userAPIs
        .findByRole(clientId)
        .then(resp => {
          this.adStrategist = resp.users;
          if (assignedTo) {
            resp.users.map(item => {
              assignedTo.map(id => {
                if (item.id === id) {
                  this.selectedCSList.push(id)
                }
              })
            })
          }
        })
        .catch(err => console.error(err));
    },
    fetchAMlist(assignedTo) {
      userAPIs
        .getAllUsersByRole(config.userRoles.ACCOUNT_MANAGER)
        .then(resp => {
          this.accountManagers = resp.users;
          if (assignedTo) {
            resp.users.map(item => {
              assignedTo.map(id => {
                if (item.id === id) {
                  this.selectedAMList.push(id)
                }
              })
            })
          }
        })
        .catch(err => console.error(err))
    },
    async getAssignUsers() {
      // Get all CO user by role
      let resp = await userAPIs.getAllUsersByRole(config.userRoles.AD_STRATEGIST)
      if (resp) this.CO = resp.users;
      // Get all AM user by role
      resp = await userAPIs.getAllUsersByRole(config.userRoles.ACCOUNT_MANAGER)
      if (resp) this.AM = resp.users
      this.assignUsers = Object.assign([], [...this.CO, ...this.AM])
      if (this.campaignData.assignedTo) {
        this.dedicatedData = this.assignUsers.filter(a => this.campaignData.assignedTo.includes(a.id))
      }
      if (this.campaignData.assignedSupportingTo) {
        this.supportingData = this.assignUsers.filter(a => this.campaignData.assignedSupportingTo.includes(a.id))
      }
    },
    updateSelectedDedicated(newValue) {
      this.selectedDedicatedPersons = Object.assign([], newValue)
    },
    updateSelectedSupporting(newValue) {
      this.selectedSupportingPersons = Object.assign([], newValue)
    }
  },
  computed: {
    cs_options() {
      // to evaluate the client list using API
      let data = this.adStrategist.map(item => {
        return {
          csData: {
            name: `${item.firstName} ${item.lastName}`,
            id: item.id
          },
          display: item.firstName
        };
      });
      return data;
    },
    am_options() {
      let data = this.accountManagers.map(item => {
        return {
          amData: {
            name: `${item.firstName} ${item.lastName}`,
            id: item.id
          },
          display: item.firstName
        }
      })
      return data
    }
  },
  watch: {
    campaign: async function(newCampaign) {
      if (newCampaign !== null) {
        this.campaignData = newCampaign;
        // this.selectedCSList = this.campaignData.assignedTo || [];
        // this.selectedAMList = this.campaignData.assignedTo || [];
        // this.fetchCSlist(this.campaignData.clientID)
        // this.fetchAMlist()
        this.selectedCSList = [];
        this.fetchCSlist(this.campaignData.clientID, this.campaignData.assignedTo)
        this.selectedAMList = [];
        this.fetchAMlist(this.campaignData.assignedTo)
        this.getAssignUsers()
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// AssignCStoCampaignModal.vue?62e7a731